import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, PRICE } from "../data/offer";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => {
      const first = document.getElementById("hero-cta");
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-185" data-mp="19785q3q3qbdq">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-186" data-mp="197zscp1q0yrv">
          <motion.a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md items-center justify-center gap-2 whitespace-nowrap rounded-2xl bg-cta px-4 py-4 font-display text-xl font-bold uppercase tracking-wide text-navy-950 shadow-cta ring-2 ring-navy-950/10 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent" animate={reduceMotion ? undefined : {
        x: [0, -7, 7, -6, 6, -3, 3, 0]
      }} transition={{
        duration: 0.45,
        repeat: Infinity,
        repeatDelay: 1.2,
        ease: "easeInOut"
      }} data-id="element-187" data-mp="2f651kmsktkna">
            Get it now — ${PRICE}
            <ArrowRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-188" data-mp="1neyypylh18ub" />
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}